// extracted by mini-css-extract-plugin
export default {"container":"RejectEditWidget_container__H5zuf","content":"RejectEditWidget_content__xA-kb","undo":"RejectEditWidget_undo__BfgJf"};